<section>
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
<!--        Content block-->
        <div class="order-2 md:order-1 md:col-span-9 w-full">
            <div class="bg-white p-8">
                <h3 class="typography-title-s mt-0 mb-4">
                    {{'create-claim.claim_information' | translate}}:
                </h3>

<!--                Subject input-->
                <div>
                    <label for="subjectInput" class="typography-body-m-medium">
                        {{'create-claim.subject' | translate}}*
                    </label>
                    <div class="flex mt-2 mb-6">
                        <input
                            id="subjectInput"
                            type="text"
                            class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                            [class.border-danger]="subjectInvalid && claimInformation.claimInfo.subject && (claimInformation.claimInfo.subject.length < MIN_SUBJECT_LENGTH || claimInformation.claimInfo.subject.length > MAX_SUBJECT_LENGTH)"
                            [placeholder]="'create-claim.subject_placeholder' | translate"
                            [(ngModel)]="claimInformation.claimInfo.subject" (ngModelChange)="onSubjectChange()"
                            (focusout)="checkSubject()"
                        />
                    </div>
                    <p *ngIf="subjectInvalid && claimInformation.claimInfo.subject && (claimInformation.claimInfo.subject.length < MIN_SUBJECT_LENGTH || claimInformation.claimInfo.subject.length > MAX_SUBJECT_LENGTH)" class="m-0 mb-6 typography-body-m-regular text-danger">
                        {{ (claimInformation.claimInfo.subject.length || 0) < MIN_SUBJECT_LENGTH ?
                            ('create-claim.subject_too_short' | translate: {varCharacters: MIN_SUBJECT_LENGTH}) :
                            ('create-claim.subject_too_long' | translate: {varCharacters: MAX_SUBJECT_LENGTH}) }}
                    </p>
                </div>

<!--                Description input-->
                <div class="flex flex-col gap-2">
                    <label for="descriptionInput" class="typography-body-m-medium">
                        {{'create-claim.text_area' | translate}}*
                    </label>
                    <p class="m-0 typography-body-s-regular">
                        {{'create-claim.text_area_description' | translate}}
                    </p>
                    <textarea
                        id="descriptionInput"
                        class="p-4 h-[108px] typography-body-m-regular border border-border-secondary outline-none resize-none"
                        placeholder="{{'create-claim.description_placeholder' | translate: {varCharacters: MIN_DESCRIPTION_LENGTH} }}"
                        [(ngModel)]="claimInformation.claimInfo.description" (ngModelChange)="onDescriptionChange()"
                        (focusout)="checkDescription()"
                    ></textarea>
                    <p *ngIf="descriptionIncomplete && claimInformation.claimInfo.description && claimInformation.claimInfo.description.length < MIN_DESCRIPTION_LENGTH" class="m-0 mt-2 typography-body-m-regular text-danger">
                        {{'create-claim.description_too_small' | translate: {varCharacters: MIN_DESCRIPTION_LENGTH} }}
                    </p>
                </div>
                <div class="divider mt-6 mb-8"></div>

                <h3 class="typography-title-s mt-0 mb-4">
                    {{'create-claim.other_details' | translate}}:
                </h3>

<!--                Purchase order input-->
                <div class="flex flex-col gap-1 mb-8">
                    <label for="purchaseOrderInput" class="typography-body-m-medium">
                        {{'create-claim.purchase_order' | translate}}
                    </label>
                    <p class="m-0 typography-body-s-regular text-text-secondary">
                        {{'create-claim.purchase_order_description' | translate}}
                    </p>
                    <div class="flex">
                        <input
                            id="purchaseOrderInput"
                            class="py-2 px-4 flex-1 typography-body-m-regular border border-border-secondary"
                            placeholder="{{'create-claim.purchase_order_placeholder' | translate}}"
                            [(ngModel)]="claimInformation.claimInfo.purchaseOrder" (ngModelChange)="onClaimInfoChange()"
                        >
                        <div class="flex-none md:flex-1"></div>
                    </div>
                </div>

<!--                Personal note input-->
                <div class="flex flex-col gap-2">
                    <label for="personalNoteInput" class="typography-body-m-medium">
                        {{'create-claim.notes' | translate}}
                    </label>
                    <textarea
                        id="personalNoteInput"
                        class="p-4 h-[48px] typography-body-m-regular border border-border-secondary bg-semantic-background-warning outline-none resize-none"
                        placeholder="{{'create-claim.notes_placeholder' | translate}}"
                        [(ngModel)]="claimInformation.claimInfo.personalNote" (ngModelChange)="onClaimInfoChange()"
                    ></textarea>

                </div>
            </div>
        </div>

<!--        Information block-->
        <div class="order-1 md:order-2 md:col-span-3 w-full">
            <div class="bg-background-medium-02 py-4 px-6">
                <div class="flex flex-col gap-4">
                    <img class="w-[32px] h-[32px]" src="assets/icons/info.svg" alt="info" />
                    <h2 class="typography-title-m m-0">{{'create-claim.now_you_can_add_multiple_materials' | translate}}</h2>
                    <div>
                        <p class="typography-body-l-medium m-0">
                            {{'create-claim.how_to_do_it' | translate}}
                        </p>
                        <ul class="ps-6 m-0">
                            <li class="typography-body-l-regular">
                                {{'create-claim.add_materials_to_claim_instructions' | translate}}
                            </li>
                        </ul>
                    </div>
                    <p class="typography-body-l-regular m-0">
                        {{'create-claim.materials_will_have_same_data_applied' | translate}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
